export default __webpack_public_path__ + "static/media/possiblities-bg-right.499a1454.png";